// ======================================================================
// File Name       : configFile
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/configFile';

export function getDownloadConfigFileResult(recordNum, userfrontDownloadResultList) {
  return {
    type: ActionTypes.GET_DOWNLOAD_CONFIG_FILE_RESULT,
    recordNum,
    userfrontDownloadResultList,
  };
}

export function resetDataDownloadConfigFile() {
  return {
    type: ActionTypes.RESET_DOWNLOAD_CONFIG_FILE,
  };
}

export function getUploadConfigFileResult(recordNum, userfrontUploadResultList) {
  return {
    type: ActionTypes.GET_UPLOAD_CONFIG_FILE_RESULT,
    recordNum,
    userfrontUploadResultList,
  };
}

export function resetDataUploadConfigFile() {
  return {
    type: ActionTypes.RESET_UPLOAD_CONFIG_FILE,
  };
}